import { NAVIGATION_FROM_APP_CODE } from '@/constants/common';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { getCookieValue, isFromVrApp } from '@/utils/helper';
import MagnifyingGlass from '../icons/MagnifyingGlass';
import RecentIcon from '../icons/RecentIcon';
interface Props {
  recentSearch: string;
  onClick: (search: string) => void;
  isRecentSearch?: boolean;
}
const SearchItem = ({
  isRecentSearch,
  recentSearch,
  onClick
}: Props) => {
  const isVR = isFromVrApp(getCookieValue(NAVIGATION_FROM_APP_CODE));
  const {
    isEnabled
  } = useFeatureFlags();
  const enableNewSearch = isEnabled('enable_new_search', true);
  const showNewSearch = isVR || enableNewSearch;
  return <div className="flex items-center cursor-pointer px-2" onClick={() => onClick(recentSearch)} data-sentry-component="SearchItem" data-sentry-source-file="RecentSearches.tsx">
      <div className="shrink-0">
        {!showNewSearch ? <RecentIcon style={{
        marginTop: 3
      }} /> : isRecentSearch ? <RecentIcon style={{
        marginTop: 3
      }} /> : <MagnifyingGlass className="fill-transparent stroke-neutral-80 w-6 h-6" />}
      </div>

      <p className={`${isVR ? 'ml-3 text-lg' : 'ml-2 text-sm'} text-[#5A6066]`}>
        {recentSearch}
      </p>
    </div>;
};
export default SearchItem;